import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { MessageUtil } from 'src/app/utils/message.util';
import { StorageUtil } from 'src/app/utils/storage.util';
import { ToastService } from 'src/app/services/toast.service';
import { MarinaMessage } from 'src/app/models/marina-message';
import { MarinaMessageVariables } from 'src/app/models/marina-message-variables';
import { MarinaMessageService } from 'src/app/services/marina-message.service';

@Component({
  selector: 'app-marina-message-edit',
  templateUrl: './marina-message-edit.component.html',
  styleUrls: ['./marina-message-edit.component.scss']
})
export class MarinaMessageEditComponent implements OnInit {

  // Propriedades para mensagens personalizadas
  selectedMessageType: string;
  marinaMessage: MarinaMessage;
  availableVariables: MarinaMessageVariables[] = [];
  customMessage: string = '';

  private currentMarina: any;

  constructor(
    private marinaMessageService: MarinaMessageService,
    private messageUtil: MessageUtil,
    private toasty: ToastService,
    public dialogRef: DynamicDialogRef,
    private spinner: NgxSpinnerService,
    private config: DynamicDialogConfig
  ) {
    this.currentMarina = StorageUtil.getMarina();
  }

  ngOnInit(): void {
    if (this.config.data) {
      this.selectedMessageType = this.config.data.messageType;
      this.customMessage = this.config.data.messageText || '';
      this.loadVariables();
      this.loadExistingMessage();
    }
  }


  loadExistingMessage(): void {
    if (this.selectedMessageType) {
      this.spinner.show();
      this.marinaMessageService.listMarinaMessageForType(this.currentMarina.id, this.selectedMessageType)
        .subscribe({
          next: (message) => {
            if (message) {
              this.marinaMessage = message;
              this.customMessage = message.messageText;
            } else {
              this.marinaMessage = null;
              this.customMessage = '';
            }
            this.spinner.hide();
          },
          error: (error) => {
            console.error('Erro ao carregar mensagem:', error);
            this.marinaMessage = null;
            this.customMessage = '';
            this.spinner.hide();
          }
        });
    }
  }

  loadVariables(): void {
    if (this.selectedMessageType) {
      this.marinaMessageService.listVariablesForType(this.selectedMessageType)
        .subscribe({
          next: (variables) => {
            this.availableVariables = variables;
          },
          error: (error) => {
            console.error('Erro ao carregar variáveis:', error);
            this.availableVariables = [];
          }
        });
    }
  }

  insertVariable(varName: string): void {
    const textarea = document.querySelector('textarea[name="customMessage"]') as HTMLTextAreaElement;
    if (textarea) {
      const start = textarea.selectionStart;
      const end = textarea.selectionEnd;
      const text = this.customMessage || '';
      const before = text.substring(0, start);
      const after = text.substring(end, text.length);

      this.customMessage = before + varName + after;

      setTimeout(() => {
        const newPosition = start + varName.length;
        textarea.setSelectionRange(newPosition, newPosition);
        textarea.focus();
      }, 0);
    }
  }

  save(): void {
    // Validação: texto não pode ser vazio
    if (!this.customMessage || !this.customMessage.trim()) {
      this.toasty.error('Por favor, digite o conteúdo da mensagem.');
      return;
    }

    // Validação: tipo de mensagem deve estar definido
    if (!this.selectedMessageType) {
      this.toasty.error('Tipo de mensagem não definido.');
      return;
    }

    this.spinner.show();

    const messageToSave: MarinaMessage = {
      id: this.marinaMessage?.id,
      idMarina: this.currentMarina.id,
      messageType: this.selectedMessageType,
      messageText: this.customMessage.trim() // Remove espaços em branco no início e fim
    };

    this.marinaMessageService.save(messageToSave)
      .subscribe({
        next: (savedMessage) => {
          this.spinner.hide();
          this.toasty.success('Mensagem salva com sucesso!');
          this.dialogRef.close(savedMessage);
        },
        error: (error) => {
          this.spinner.hide();
          console.error('Erro ao salvar mensagem:', error);

          // Tratamento de erros mais específico
          if (error.status === 400) {
            this.toasty.error('Dados inválidos. Verifique o conteúdo da mensagem.');
          } else if (error.status === 404) {
            this.toasty.error('Mensagem não encontrada.');
          } else if (error.status === 500) {
            this.toasty.error('Erro interno do servidor. Tente novamente.');
          } else {
            this.toasty.error('Erro ao salvar mensagem. Tente novamente.');
          }
        }
      });
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
